//class
import PadEditor from './PadEditor';

/**
 * represents an instance of PadEditorEquipment
 * @class PadEditorEquipment
 * @extends PadEditor
 */
export default class PadEditorEquipment extends PadEditor {
  prepare(equipments = []) {
    const preparedEquipments = equipments.map(equipment => ({
      id: equipment.id,
      code: equipment.code,
      amount: equipment.amount,
      type: equipment.type,
      itemId: equipment.itemId,
      unityPrice: equipment.unityPrice,
      name: equipment.equipmentName,
      status: equipment.status
    }));

    this._loadedData = preparedEquipments;
    this._screenData = preparedEquipments;

    return this;
  }
}
